/**
 * @desc 物流渠道仓库关系表导出
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.logisticsChannelWarehouse.exporting.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannelWarehouse/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
